// src/components/layout/Layout.js
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Sidebar from './Sidebar';
import { useStore } from '../../store';
import { authAPI } from '../../utils/api';

function VerifyEmailBanner({ email }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const resend = async () => {
    setSending(true);
    try {
      await authAPI.resendVerification(email);
      setSent(true);
      toast.success(`Verification link sent to ${email}`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not send the email');
    } finally { setSending(false); }
  };
  return (
    <div style={{ background: '#fff8e7', borderBottom: '1px solid #f5e1b0', color: '#8a6200', fontSize: 12, padding: '8px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
      <span>Please verify <strong>{email}</strong> — you'll need it to reset your password.</span>
      <button className="btn btn-outline" style={{ padding: '3px 10px' }} disabled={sending || sent} onClick={resend}>
        {sent ? 'Link sent — check your inbox' : sending ? 'Sending…' : 'Resend link'}
      </button>
    </div>
  );
}

// Renders the matched child route, or `children` when used directly (NotFound).
export default function Layout({ children }) {
  const navigate = useNavigate();
  const user = useStore(s => s.user);
  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        {/* Top navigation bar */}
        <div className="topbar">
          <div className="topbar-tabs">
            <div className="topbar-tab active">Post Calendar</div>
          </div>
          <div className="topbar-right">
            <button className="btn btn-create" onClick={() => navigate('/posts/create')}>
              + Create Post
            </button>
          </div>
        </div>
        {user && !user.email_verified_at && <VerifyEmailBanner email={user.email} />}
        <div className="page">
          {children || <Outlet />}
        </div>
      </div>
    </div>
  );
}
